module.exports = __webpack_public_path__ + "static/media/frog(22).1affe996.PNG";